import React, {Component} from 'react';
import * as messageConstants from '../../shared/messages';

class AppNames extends Component {

  render() {
    return (
        <div className="row">
          <div className="col-xs-12 col-sm-8">
            <div className="sba-name-placeholder">
              <label
                  htmlFor="sbaApplicationNameInput"
                  className="sba-label-title">{messageConstants.SBA_APPNAME_LABEL}</label>
              <input
                  id="sbaApplicationNameInput"
                  type="text"
                  className="form-control app-name"
                  value={this.props.applicationName}
                  onChange={this.props.handleChangeAppName}
                  placeholder="This name is visible only to admins"
                  aria-invalid={Boolean(this.props.errorMessage)}
                  aria-describedby={this.props.errorMessage ? "sbaApplicationNameError" : undefined}
              />
              {this.props.errorMessage ? (
                  <div id="sbaApplicationNameError" className="help-block warning">
                    {this.props.errorMessage}
                  </div>
              ) : null}
            </div>
          </div>
        </div>
    );
  }
}

export default AppNames;
